export default "__VITE_ASSET__anFSncko__"